import React, { useState } from 'react';
import { Mail, Smartphone } from 'lucide-react';
import { toast } from 'sonner';
import { api, errMsg } from '../api';
import { Card, goldBtn } from '../ui';

const field = 'h-10 px-3 text-sm bg-transparent border border-[#1F242C] rounded-sm text-[#E5E5E5] outline-none focus:border-[#D4AF37] w-full min-w-0';

export default function TripContact({ trip, onSaved }) {
  const [f, setF] = useState({ traveler_email: trip.traveler_email || '', traveler_phone: trip.traveler_phone || '' });
  const [busy, setBusy] = useState(false);
  const save = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const r = await api.put(`/travel/trips/${trip.id}/contact`, { traveler_email: f.traveler_email.trim() || null, traveler_phone: f.traveler_phone.trim() || null });
      setF({ traveler_email: r.data.traveler_email || '', traveler_phone: r.data.traveler_phone || '' });
      toast.success('Contatti del viaggiatore salvati');
      onSaved?.();
    } catch (err) { toast.error(errMsg(err)); } finally { setBusy(false); }
  };
  return (
    <Card className="p-6" data-testid="trip-contact">
      <p className="text-[11px] uppercase tracking-[0.18em] text-[#D4AF37] mb-1">Contatti del viaggiatore</p>
      <p className="text-xs text-[#8A8F97] mb-4">Usati per gli alert quando il rischio del Paese sale: email e SMS.</p>
      <form onSubmit={save} className="space-y-3">
        <label className="flex items-center gap-2"><Mail size={15} className="text-[#8A8F97] shrink-0" />
          <input type="email" value={f.traveler_email} onChange={(e) => setF({ ...f, traveler_email: e.target.value })} placeholder="email@azienda.it" className={field} data-testid="trip-contact-email" />
        </label>
        <label className="flex items-center gap-2"><Smartphone size={15} className="text-[#8A8F97] shrink-0" />
          <input type="tel" value={f.traveler_phone} onChange={(e) => setF({ ...f, traveler_phone: e.target.value })} placeholder="+39 333 1234567" className={field} data-testid="trip-contact-phone" />
        </label>
        <button type="submit" disabled={busy} className={`${goldBtn} h-10 px-5 text-sm w-full`} data-testid="trip-contact-save">Salva contatti</button>
      </form>
    </Card>
  );
}
